export default "__VITE_ASSET__5zEURpA0__"